export const SUB_DOMAIN_PREFIX_MAX_LENGTH = 63;
export const DOMAIN_MAX_LENGTH = 127;
export const ROOT_PREFIX = '';
export const MAX_SUB_DOMAINS = 10;

export const WHITE_LABEL_DOMAIN_DOCS_URL = 'https://docs.droxy.ai/documentation/enterprise/whitelabel';
export const WHITE_LABEL_DOMAIN_TROUBLESHOOTING_DOCS_URL = `${WHITE_LABEL_DOMAIN_DOCS_URL}#troubleshooting`;
